export const LIMIT_SCREEN_SMALL = 600
export const LIMIT_SCREEN_MEDIUM = 750